"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// filename is in the form of BaseName-theme.css
// we need to extract the "theme" portion
var _default = function _default(fn) {
  if (typeof fn !== 'string') {
    return '';
  }
  var dash = fn.lastIndexOf('-');
  var period = fn.indexOf('.css');
  if (dash === -1 || period === -1) {
    return '';
  }
  return fn.substring(dash + 1, period);
};
exports.default = _default;